import { render, staticRenderFns } from "./priceDialog.vue?vue&type=template&id=5eb2c2c6"
import script from "./priceDialog.vue?vue&type=script&lang=js"
export * from "./priceDialog.vue?vue&type=script&lang=js"
import style0 from "./priceDialog.vue?vue&type=style&index=0&id=5eb2c2c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports